/** F1 / ?: every key and mouse button the kit knows. */

import { LIGHT_BLUE, WHITE, YELLOW } from '../../../render/palette';
import type { KitApi } from '../api';
import { INK } from '../layout';
import type { Ui } from '../widgets';
import { button, dialog } from '../widgets';
import type { Modal } from './modal';

type Row = readonly [string, string];

const KEYS: readonly Row[] = [
  ['ARROWS', 'MOVE THE CURSOR (SHIFT: 8)'],
  ['SPACE  ENTER', 'USE THE TOOL AT THE CURSOR'],
  ['DEL', 'DIRT AT THE CURSOR'],
  ['D  L  R', 'PENCIL, LINE, RECTANGLE'],
  ['B  F  I', 'BLOCK, FLOOD FILL, PICKER'],
  ['[ ]  OR  , .', 'PREVIOUS / NEXT ELEMENT'],
  ['CTRL+Z  CTRL+Y', 'UNDO / REDO (100 STEPS)'],
  ['Z  G  V', 'ZOOM, GRID, SHOW ? ROLLS'],
  ['PGUP/DN HOME/END', 'SCROLL A SCREEN'],
  ['TAB', 'SETTINGS: ARROWS CHANGE,'],
  ['', 'ENTER TYPES, ESC GOES BACK'],
  ['T  CTRL+S  C', 'TEST, SAVE, SHARE'],
  ['N  O', 'NEW CAVE, LIBRARY'],
  ['ESC', 'CANCEL A SHAPE, OR LEAVE'],
  ['F1  ?', 'THIS HELP'],
];

const MOUSE: readonly Row[] = [
  ['LEFT', 'PAINT THE ELEMENT'],
  ['RIGHT', 'PAINT DIRT'],
  ['MIDDLE', 'DRAG TO SCROLL'],
  ['WHEEL', 'SCROLL THE CAVE'],
  ['WHEEL ON', 'A NUMBER, A COLOUR'],
  ['', 'OR THE PALETTE:'],
  ['', 'CHANGE IT'],
  ['HOLD ◄ ►', 'STEP, THEN FASTER'],
  ['FILL SLOT', 'CLICK: SELECTED'],
  ['', 'ELEMENT; RIGHT:'],
  ['', 'REMOVE'],
];

const TIPS: readonly string[] = [
  'A CAVE NEEDS ONE INBOX P AND AN EXIT X; KEEP STEEL ALL ROUND.',
  '? CELLS ROLL FROM THE FILL SETTINGS; A NEW SEED GIVES A NEW LAYOUT.',
  'TEST PLAYS IT AT ONCE. ESC IN THE CAVE BRINGS YOU BACK HERE.',
];

function rows(ui: Ui, list: readonly Row[], x: number, y: number, keyW: number): void {
  list.forEach(([key, value], i) => {
    ui.screen.text(key, x, y + i * 11, YELLOW);
    ui.screen.text(value, x + keyW, y + i * 11, WHITE);
  });
}

export function helpModal(k: KitApi): Modal {
  return {
    draw(ui) {
      const r = dialog(ui, 624, 272, 'CONSTRUCTION KIT: KEYS AND MOUSE');
      const s = ui.screen;
      s.text('KEYBOARD', r.x + 10, r.y + 16, LIGHT_BLUE);
      rows(ui, KEYS, r.x + 10, r.y + 30, 136);
      s.text('MOUSE', r.x + 374, r.y + 16, LIGHT_BLUE);
      rows(ui, MOUSE, r.x + 374, r.y + 30, 80);
      TIPS.forEach((t, i) => s.text(t, r.x + 10, r.y + 203 + i * 11, INK.text));
      button(ui, { x: r.x + r.w - 112, y: r.y + r.h - 24, w: 100, h: 16 }, 'CLOSE', {
        id: 'help-close', tip: 'ANY KEY CLOSES THIS', click: () => k.closeModal(),
      });
    },
    key() {
      k.closeModal();
    },
  };
}
